export const GET_TOKEN = 'GET_TOKEN';
export const LOGIN = 'LOGIN';
export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const DELETE_USERS = 'DELETE_USERS';
export const LOGIN_DETAILS = 'LOGIN_DETAILS';

export const RESET = 'RESET';
export const REGISTER = 'REGISTER';

export const PATIENTS_LIST = 'PATIENTS_LIST';
export const CLINIC_LIST = 'CLINIC_LIST';
export const ADD_CLINIC = 'ADD_CLINIC';
export const SET_INFO = 'SET_INFO';
export const GET_CLINIC_DETAILS = 'GET_CLINIC_DETAILS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const PATIENT_DETAILS = 'PATIENT_DETAILS';
export const SET_TRANSFER = 'SET_TRANSFER';
export const COMPILANCE_LIST = 'COMPILANCE_LIST';
export const SET_CURVES = 'SET_CURVES';
export const CLINIC = 'CLINIC';
export const SET_STATUS = 'SET_STATUS';
export const GET_DIAGNOSIS = 'GET_DIAGNOSIS';
export const SET_DIAGNOSIS = 'SET_DIAGNOSIS';
export const SET_DIAGNOSIS_IMAGE = 'SET_DIAGNOSIS_IMAGE';
export const SET_PASS = 'SET_PASS';
export const CLEAR_SELECTED_PATIENT = 'CLEAR_SELECTED_PATIENT';
export const DIAGNOSIS_LOAD = 'DIAGNOSIS_LOAD';
export const REMOVE_CLINIC = 'REMOVE_CLINIC';
export const REMOVE_USER_CLINIC = 'REMOVE_USER_CLINIC';
export const REMOVE_PAITENT_CLINIC = 'REMOVE_PAITENT_CLINIC';
export const USERS_CLINIC = 'USERS_CLINIC';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';

export const SET_ALL_PATIENTS = 'SET_ALL_PATIENTS';
export const SET_ALL_ADMINS = 'SET_ALL_ADMINS';
// MESSAGES
export const SET_ERROR = 'SET_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const SET_IS_LOADING = 'SET_IS_LOADING';
// MODALS
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
// nav
export const HISTORY = 'HISTORY';
export const SET_HISTORY = 'SET_HISTORY';
export const GO_BACK = 'GO_BACK';
export const CLEAR_HISTORY = 'CLEAR_HISTORY';
export const SET_SELECTED_BUTTON = 'SET_SELECTED_BUTTON';
//filter
export const SET_SEARCH_TXT = 'SET_SEARCH_TXT';
export const SET_FILTER_STATUS = 'SET_FILTER_STATUS';
export const SET_TIME_FRAME = 'SET_TIME_FRAME';
